import { Category } from "#sitis/internal/controllers/categories/models/Category";
export class GetCategoriesUseCase {
  constructor(agent) {
    this.agent = agent;
  }
  async getCategories(perPage = 999) {
    try {
      const categoriesRes = await this.agent.get("/categories", {
        query: { "per-page": perPage }
      });
      let categories = [];
      if (categoriesRes._data) {
        categories = categoriesRes._data.map((data) => new Category(data).toJSON());
      }
      return categories;
    } catch (ex) {
      throw ex;
    }
  }
  async getCategoryBySlug(params) {
    const response = await this.agent.get(`/categories/${params.slug}`, {
      query: { ...params.queryParams }
    }).then((res) => res).catch((err) => {
      throw err.response;
    });
    if (response && response._data) {
      return {
        _data: new Category(response._data).toJSON(),
        headers: response.headers
      };
    }
  }
}
